export { FORCE_CACHE_RESET_AT_VERSION } from './forceCacheReset';
export * as routes from './systemRoutes';
export { device } from './devicesScreens';
export { default as searchTerms } from './searchTerms';
export { default as sem_imagem } from './sem_imagem';
export { default as colors } from './systemColors';

export const ENCRYPT = !window.location.hostname.includes('localhost') && !window.location.hostname.includes('rca-dev') && !window.location.hostname.includes('rca2-dev') && !window.location.hostname.includes('192.168.0.225'); //process.env.NODE_ENV !== 'development'
// export const ENCRYPT = false
export const DISABLE_SERVICE_WORKER = window.agp_config?.DISABLE_SERVICE_WORKER || false;

export const UUID_NAMESPACE = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';

export const TIMEZONE_MS = 'America/Campo_Grande';